import { AfterViewInit, Directive, ElementRef, Input, NgModule, OnDestroy } from '@angular/core';

import { TeleporterService } from '../services/teleporter.service';
import { TeleporterKey } from '../types/teleporter.type';

@Directive({
	standalone: false,
	selector: '[teleporterItem]',
})
export class TeleporterItemDirective implements AfterViewInit, OnDestroy {
	private key: TeleporterKey;

	@Input()
	public set teleporterItem(key: TeleporterKey) {
		if (this.key !== key) {
			try {
				this.teleporterService.removeItem(this.key);
			} catch (error) {}
			this.key = key;

			if (this.viewInitialized) {
				this.teleporterService.setItem(this.key, this.elementRef.nativeElement);
			}
		}
	}

	public get teleporterItem(): TeleporterKey {
		return this.key;
	}

	private viewInitialized = false;

	constructor(
		private readonly elementRef: ElementRef<HTMLElement>,
		private readonly teleporterService: TeleporterService
	) {}

	ngAfterViewInit(): void {
		this.teleporterService.setItem(this.key, this.elementRef.nativeElement);
		this.viewInitialized = true;
	}

	ngOnDestroy(): void {
		this.teleporterService.removeItem(this.teleporterItem);
	}
}

@NgModule({
	declarations: [TeleporterItemDirective],
	exports: [TeleporterItemDirective],
})
export class TeleporterItemModule {}
